console.log('Hello from MilesHong.com!');


document.addEventListener("DOMContentLoaded", function() {
    // 1. Normalize path: Lowercase and strip trailing index.html
    const path = window.location.pathname.toLowerCase().replace(/index\.html$/, '');
    
    // 2. Clear existing states
    document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
    });
    
    let activeId = '';

    // 3. Check clean path (Note: path will now be '/' or '/folder/')
    if (path === '/' ) {
        activeId = 'nav-home';
    } else if (path.includes('/about')) { 
        activeId = 'nav-about';
    } else if (path.includes('/babies')) {
        activeId = 'nav-babies'; 
    } else if (path.includes('/technotes')) {
        activeId = 'nav-technotes';
    } else if (path.includes('/blog')) {
        activeId = 'nav-blog';
    }

    if (activeId) {
        const activeLink = document.querySelector(`#${activeId} .nav-link`);
        if (activeLink) {
            activeLink.classList.add('active');
            console.log(`Set active nav link: ${activeId}`);
        }
    }

    function initBlogPagination() {
        const grid = document.querySelector('.blog-grid');
        if (!grid) return;

        const cards = Array.from(grid.querySelectorAll('.blog-card'));
        if (!cards.length) return;

        const paginationRoot = document.querySelector('.blog-pagination .pagination');
        if (!paginationRoot) return;

        const itemsPerPage = 9;
        const totalPages = Math.max(1, Math.ceil(cards.length / itemsPerPage));
        let currentPage = 1;

        function applyPage(page) {
            currentPage = Math.min(Math.max(1, page), totalPages);
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;

            cards.forEach((card, index) => {
                card.hidden = index < start || index >= end;
            });
            renderPagination();

            if (history.replaceState) {
                if (currentPage === 1) {
                    const cleanUrl = window.location.origin + window.location.pathname + window.location.search;
                    history.replaceState(null, '', cleanUrl);
                } else {
                    history.replaceState(null, '', `#page-${currentPage}`);
                }
            } else {
                if (currentPage === 1) {
                    window.location.hash = '';
                } else {
                    window.location.hash = `page-${currentPage}`;
                }
            }
        }

        function createPageButton(page, label, isActive, isDisabled) {
            const item = document.createElement('li');
            item.className = `page-item${isActive ? ' active' : ''}${isDisabled ? ' disabled' : ''}`;

            const link = document.createElement('a');
            link.className = 'page-link';
            link.href = '#';
            link.textContent = label;
            link.addEventListener('click', event => {
                event.preventDefault();
                if (isDisabled || page === currentPage) return;
                applyPage(page);
            });

            item.appendChild(link);
            return item;
        }

        function renderPagination() {
            paginationRoot.innerHTML = '';
            paginationRoot.appendChild(createPageButton(currentPage - 1, 'Previous', false, currentPage === 1));

            for (let page = 1; page <= totalPages; page += 1) {
                paginationRoot.appendChild(createPageButton(page, page.toString(), page === currentPage, false));
            }

            paginationRoot.appendChild(createPageButton(currentPage + 1, 'Next', false, currentPage === totalPages));
        }

        const hashPage = parseInt(window.location.hash.replace('#page-', ''), 10);
        if (!Number.isNaN(hashPage) && hashPage >= 1 && hashPage <= totalPages) {
            currentPage = hashPage;
        }

        applyPage(currentPage);
    }

    initBlogPagination();
});

